import React, { memo, useMemo } from "react";
import { useRegUIClient } from "@foundation/reg-ui-client";
import { Placeholder } from "@bloomberg/media-ui-article";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./watchlistWrapped.module.css";
import { WrappedContentPlaceholder } from "~components/WatchlistWrapped/contentPlaceholder";
import { WrappedHeaderPlaceholder } from "~components/WrappedHeader/headerPlaceholder";

type WatchlistWrappedPlaceholderProps = {
  useGeneric?: boolean;
};

const BundlePlaceholder = () => {
  return (
    <div className={styles.bundle}>
      <Placeholder.Line />
      <Placeholder.Image className={styles.bundleImage} />
      <div className={styles.bundleTickers}>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </div>
      <div className={styles.bundleButton}>
        <Placeholder.Line />
      </div>
    </div>
  );
};

const WrappedBundlePlaceholder = memo(
  function WrappedBundlePlaceholderComponent() {
    return (
      <>
        <div className={styles.bundleHeader}>
          <div className={styles.subscriberOnly}>
            <Placeholder.Line />
          </div>
          <div className={styles.topLiner}>
            <Placeholder.Line />
          </div>
          <div className={styles.subLiner}>
            <Placeholder.Line />
          </div>
        </div>
        <div className={styles.bundlesContainer}>
          <BundlePlaceholder />
          <BundlePlaceholder />
          <BundlePlaceholder />
        </div>
      </>
    );
  }
);

export const WrappedGenericPlaceholder = memo(
  function WrappedGenericPlaceholderComponent() {
    return (
      <section className={styles.placeholderContainer}>
        <Placeholder>
          <div>
            {Array.from(Array(20).keys()).map((_, i) => (
              <div className={styles.placeholderRow} key={i}>
                <Placeholder.Line />
              </div>
            ))}
          </div>
        </Placeholder>
      </section>
    );
  }
);

export const WatchlistWrappedPlaceholder = ({ useGeneric = true }) => {
  const { session } = useRegUIClient();

  const signedIn = useMemo(() => {
    return Boolean(session?.isLoggedIn);
  }, [session?.isLoggedIn]);

  if (useGeneric) {
    return <WrappedGenericPlaceholder />;
  }

  if (!signedIn) {
    // show bundle placeholder when user is not signed in
    return (
      <section
        className={createClasses([
          styles.placeholderContainer,
          styles.bundleContainer,
        ])}
      >
        <WrappedBundlePlaceholder />
      </section>
    );
  }

  // TODO: use this placeholder when user switches watchlist after confirming with stakeholders
  return (
    <section className={styles.placeholderContainer}>
      <WrappedHeaderPlaceholder />
      <WrappedContentPlaceholder />
    </section>
  );
};
